import { dynamicLoadData } from '../page';
import { derivedPath } from './routing';
import ConfigureContainer from './configure-container';

export const loadData = async (urlParams, store, context = {}) => {
    const { query, headers } = context;
    const fullSlug = derivedPath({ params: urlParams }, query);
    await dynamicLoadData(fullSlug, store, context);

    const { slugInfo, redirects, basename } = store.getState();

    const needRedirect = !slugInfo || slugInfo.error || (redirects && redirects.count !== 0);

    const { destination = `${basename}/slp/weekly-deals`, status = 301 } = redirects;
    if (needRedirect) return Promise.resolve({ status, destination });

    return Promise.resolve(slugInfo);
};

export default {
    component: ConfigureContainer,
    loadData,
};
